import { defineStore } from 'pinia'

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useClickedStore = defineStore('overlayClicks', {
    state: () => ({
        count: 0
    }),
    actions: {
        incrementCount() {
            this.count++;

        },
        resetCount() {
            this.count = 0;
        }
    }
})

export const useMediaStore = defineStore('media', {
    state: () => ({
        isVideoPlaying: false,
        isAudioMuted: false
    }),
    actions: {
        playVideo() {
            this.isVideoPlaying = true;
            this.muteAudio();
        },
        stopVideo() {
            this.isVideoPlaying = false;
            this.unmuteAudio();
        },
        muteAudio() {
            this.isAudioMuted = true;
        },
        unmuteAudio() {
            this.isAudioMuted = false;
        }
    }
});
